import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const TermsandConditionF = () => {
  const [termsDescription, setTermsDescription] = useState("");
  const [error, setError] = useState(null);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        const response = await corefetch(
          "PoliciesandTerms/GetPoliciesAndTerms?CategoryType=TERMS"
        );
        if (response && response.length > 0) {
          setTermsDescription(response[0].description);
        }
      } catch (err) {
        setError("Failed to fetch terms and conditions.");
        console.error("Error fetching terms and conditions", err);
      }
    };
    const fetchBreadcrumImageData = async () => {
      try {
        const response = await corefetch(
          "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=TERMS"
        );
        if (response && response.length > 0) {
          console.log("fxftyxfyt:", response);
          setBreadcrumList(response);
        } else {
          setBreadcrumList([]);
          console.log("No Breadcrum found");
        }
      } catch (error) {
        console.error("Error fetching Breadcrum List:", error);
        setBreadcrumList([]);
      }
    };

    fetchTermsAndConditions();
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};
  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h3>Terms and Condtions</h3>
                <br />
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Terms and Condtions</li>
                </ol>
              </div>
            </div>
          </div>{" "}
          {/* end row */}
        </div>{" "}
        {/* end container */}
      </section>

      <section className="wpo-blog-single-section section-padding-pp">
        <div className="container" style={{ marginLeft: "42px" }}>
          <div className="row">
            <div className="col col-lg-12 ">
              <div className="wpo-blog-content">
                {error ? (
                  <p className="error-message">{error}</p>
                ) : (
                  <div
                    className="terms-and-condition"
                    dangerouslySetInnerHTML={{ __html: termsDescription }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
